<app-environment-bar></app-environment-bar>
<mat-toolbar>
    <mat-toolbar-row>
        <a href="/"><img ngSrc="assets/gourmet.png" alt="Gourmet" width="90" height="48"></a>
        <app-navigation-tabs></app-navigation-tabs>
        <span></span>
        <app-language-picker/>
        <app-role-picker *environment-feature="NON_PROD"/>
        <app-notifications></app-notifications>
        <app-profile-button [user]="securityService.user()" (logout)="securityService.logout()"></app-profile-button>
    </mat-toolbar-row>
</mat-toolbar>
